const removeAccents = (str:string) => {
const res = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

return res;
};

export default removeAccents;
